import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { useRef, useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useIntl, FormattedMessage } from "react-intl";

const PageForm = (props) => {
  const intl = useIntl();
  const [filtersExpanded, setFiltersExpanded] = useState(true);

  const handleExpandClick = () => {
    setFiltersExpanded(!filtersExpanded);
  };

  useEffect(() => {
    if (props.shouldCollapse) {
      setFiltersExpanded(false);
    }
    else{
      setFiltersExpanded(true);
    }
  }, [props.shouldCollapse]);

  return (
    <div id="form">
      <Accordion
        className="apeLigthGreyBackground"
        expanded={filtersExpanded}
        onChange={handleExpandClick}
        onTransitionEnd={props.adjustHeightFunc}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            variant="subtitle1"
            sx={{ fontSize: 16, fontWeight: "bold" }}
            className="apeDarkGreyColor"
          >
            {intl.formatMessage({ id: "General.Filters" })}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{props.form}</AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PageForm;
